export default "__VITE_ASSET__CqihUU1l__"